"use strict";

var Button = require("app/shared/components/Button/button");

var GoogleCalendarSettings = React.createClass({
  propTypes: {
    handleSave: React.PropTypes.func.isRequired,
    children: React.PropTypes.node.isRequired,
    metrics: React.PropTypes.array
  },

  render: function() {
    return (
      <div className="left-gray-border googleCalendar-settings-content">
        <div className="googleCalendar-settings-titleUnderline">
          <h3 className="c-333">Configurações</h3>
        </div>
        {this.props.children}
        <span className="bootstrap-agendor f-r mt-10">
          <Button type="primary" onClick={this.props.handleSave}>Salvar</Button>
        </span>
      </div>
    );
  }
});

module.exports = GoogleCalendarSettings;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-settings.jsx